// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"174":"05cb5fcf","522":"81e10681"}[chunkId] + ".js";
};